import { t } from "@lingui/macro";
import React from "react";

import { WhooshThemeColors } from "../../../theme/restyle/theme";
import { CurrencyIcon } from "../../icons_v2/general";
import { HStack, Text } from "../../primitive";

export type ChargePaymentStatus =
  | "AUTO_CHARGE"
  | "CANCELED"
  | "MARKED_PAID"
  | "NO_CHARGES"
  | "PAID"
  | "PARTIALLY_PAID"
  | "PARTIALLY_REFUNDED"
  | "FULLY_REFUNDED"
  | "INCOMPLETE"
  | "PROCESSING"
  | "UNKNOWN"
  | "UNPAID";

const validPaidStatuses: string[] = ["PAID", "MARKED_PAID"];

const statusToDisplayText = (status: string): string => {
  if (status === "INCOMPLETE") {
    return t`INCOMPLETE`;
  }
  if (status === "AUTO_CHARGE") {
    return "MEMBER BILL";
  }
  return status.replace("_", " ");
};

export const ChargeStatusPill = ({
  status,
}: {
  status?: ChargePaymentStatus | string;
}) => {
  if (!status || status === "UNKNOWN") {
    return null;
  }

  const textColor: WhooshThemeColors = validPaidStatuses.includes(status)
    ? "surface-main-primary-neutral"
    : "text-secondary";
  const bgColor: WhooshThemeColors = validPaidStatuses.includes(status)
    ? "surface-main-primary-subtlest"
    : "surface-secondary";

  return (
    <HStack bg={bgColor} px={2} py={1} borderRadius="2" alignItems="center">
      <CurrencyIcon variant="alt" color={textColor} />
      <Text variant="mainTiny" color={textColor}>
        {statusToDisplayText(status)}
      </Text>
    </HStack>
  );
};
